module.exports = __webpack_public_path__ + "static/img/pro-7-2-1.c2eead4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zbqfBrand/pro-7-2-1.png
// module id = Ztu1
// module chunks = 0